/**
 * backlash-guide.js
 *
 * Two markers on two tracks. The motor moves on every press. The drawtube
 * moves too - except just after a reversal, when the first few presses only
 * take up slack. The gap that opens between the markers is the backlash.
 */

const root = document.querySelector('[data-backlash-guide]');
if (root) initDemo(root);

function initDemo(root) {
  const demo = root.querySelector('[data-demo]');
  if (!demo) return;

  const $ = (s) => demo.querySelector(s);
  const motor = $('[data-demo-motor]');
  const tube = $('[data-demo-tube]');
  const gapLine = $('[data-demo-gap-line]');
  const gapLabel = $('[data-demo-gap-label]');
  const say = $('[data-demo-say]');
  const reset = $('[data-demo-reset]');

  const X0 = 120, X1 = 452, UMIN = -6, UMAX = 6, BACKLASH = 3;
  const px = (u) => X0 + ((u - UMIN) / (UMAX - UMIN)) * (X1 - X0);
  const clamp = (u) => Math.max(UMIN, Math.min(UMAX, u));

  const st = { slack: 0, dir: 0, motor: 0, tube: 0 };

  function press(dir) {
    if (dir !== st.dir && st.dir !== 0) st.slack = BACKLASH; // reversal
    st.dir = dir;
    st.motor = clamp(st.motor + dir);        // motor always responds

    let moved = false;
    if (st.slack > 0) st.slack -= 1;          // wasted step, drawtube still
    else { st.tube = clamp(st.tube + dir); moved = true; }

    render(moved);
  }

  function render(moved) {
    const mx = px(st.motor), tx = px(st.tube);
    motor.setAttribute('transform', `translate(${mx} 0)`);
    tube.setAttribute('transform', `translate(${tx} 0)`);

    const lo = Math.min(mx, tx), hi = Math.max(mx, tx);
    gapLine.setAttribute('x1', lo);
    gapLine.setAttribute('x2', hi);
    gapLabel.setAttribute('x', (lo + hi) / 2);

    demo.dataset.state = st.dir === 0 ? 'idle' : moved ? 'live' : 'dead';

    say.textContent =
      st.dir === 0
        ? 'Press a button to move the focuser, then reverse direction.'
        : moved
          ? 'Engaged - the motor and the drawtube move together.'
          : 'The motor is moving, but the drawtube is not. Those steps are wasted - that is the backlash.';
  }

  demo.querySelectorAll('[data-demo-turn]').forEach((b) =>
    b.addEventListener('click', () => press(Number(b.dataset.demoTurn)))
  );
  reset?.addEventListener('click', () => {
    Object.assign(st, { slack: 0, dir: 0, motor: 0, tube: 0 });
    render();
  });

  render();
}
